import { useState, useEffect, useCallback } from "react";

import { PencilSquareIcon } from "@heroicons/react/24/outline";

// Page constants
export const PAGES = {
  NAME: "name",
  ACCOUNTS: "accounts",
  EDIT_MENU: "editMenu",
  DELETE: "delete",
};

export function useGroupModal({ isOpen, editingGroup, onReset }) {
  const [page, setPage] = useState(PAGES.NAME);
  const isEditMode = !!editingGroup;

  // Set initial page based on mode
  useEffect(() => {
    if (isOpen) {
      setPage(editingGroup ? PAGES.EDIT_MENU : PAGES.NAME);
    }
  }, [isOpen, editingGroup]);

  // Reset page when modal closes
  useEffect(() => {
    if (!isOpen) {
      setPage(PAGES.NAME);
      onReset?.();
    }
  }, [isOpen, onReset]);

  const goToName = useCallback(() => setPage(PAGES.NAME), []);
  const goToAccounts = useCallback(() => setPage(PAGES.ACCOUNTS), []);
  const goToEditMenu = useCallback(() => setPage(PAGES.EDIT_MENU), []);
  const goToDelete = useCallback(() => setPage(PAGES.DELETE), []);

  const getModalTitle = useCallback(
    (groupName) => {
      switch (page) {
        case PAGES.EDIT_MENU:
          return (
            <span className="flex items-center gap-2">
              <PencilSquareIcon className="size-4" /> Edit {groupName}
            </span>
          );
        case PAGES.NAME:
          return isEditMode ? "Change group name" : "Group name";
        case PAGES.DELETE:
          return `Delete ${groupName}`;
        case PAGES.ACCOUNTS:
        default:
          return groupName;
      }
    },
    [page, isEditMode],
  );

  return {
    page,
    isEditMode,
    goToName,
    goToAccounts,
    goToEditMenu,
    goToDelete,
    getModalTitle,
  };
}
